import { ReactNode } from 'react';
import { FloraTypography, FloraTypographyProps, useIsMobile } from '@grupoboticario/flora-react';
import { ColorThemeProps } from '@grupoboticario/flora';

interface ResponsiveFloraTypographyProps extends FloraTypographyProps {
  children: ReactNode;
  color?: ColorThemeProps | string;
  css?: Record<string, any>;
}

export const ResponsiveFloraTypography = ({
  children,
  color: colorProps,
  css,
  ...props
}: ResponsiveFloraTypographyProps) => {
  const isMobile = useIsMobile();
  return (
    <FloraTypography
      viewport={isMobile ? 'mobile' : 'desktop'}
      {...props}
      css={{ ...css, color: colorProps }}
    >
      {children}
    </FloraTypography>
  );
};
